import React, { Fragment } from 'react';
import Table from '../table/Table';
import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import { getStatusStyle, has_value } from '../../utils/utility';

export class SystemEvaluationResult extends React.Component {
  render() {
    const {
      evaluation: {
        envelope,
        lighting_system,
        air_conditioning,
        hot_water_system,
      },
      t,
    } = this.props;
    const evaluationHeader = [<span />, <span>{t('result')}</span>];
    const evaluationResults = [
      [t('OTTV'), ({
        value: t(envelope.OTTV.status.toLowerCase()).toUpperCase(),
        customStyle: getStatusStyle(envelope.OTTV.status.toLowerCase())
      })],
      [t('RTTV'), ({
        value: t(envelope.RTTV.status.toLowerCase()).toUpperCase(),
        customStyle: getStatusStyle(envelope.RTTV.status.toLowerCase())
      })],
      [t('LPD'), ({
        value: t(lighting_system.status.toLowerCase()).toUpperCase(),
        customStyle: getStatusStyle(lighting_system.status.toLowerCase())
      })],
      [t('A/C'), ({
        value: t(air_conditioning.status.toLowerCase()).toUpperCase(),
        customStyle: getStatusStyle(air_conditioning.status.toLowerCase())
      })],
      [t('hot water equipment'), ({
        value: t(hot_water_system.status.toLowerCase()).toUpperCase(),
        customStyle: getStatusStyle(hot_water_system.status.toLowerCase())
      })],
    ];
    return <Table header={evaluationHeader} data={evaluationResults} />;
  }
}

export class EnergyEvaluationResult extends React.Component {
  render() {
    const {
      evaluation: { whole_building_energy, hot_water_system },
      t,
    } = this.props;

    const evaluationHeader = [<span />, <span>{t('result')}</span>];
    const evaluationResults = [
      [
        t('whole building energy'), ({
          value: t(whole_building_energy.status.toLowerCase()).toUpperCase(),
          customStyle: getStatusStyle(whole_building_energy.status.toLowerCase()),
        }),
      ],
      [
        t('hot water equipment'), ({
          value: t(hot_water_system.status.toLowerCase()).toUpperCase(),
          customStyle: getStatusStyle(hot_water_system.status.toLowerCase()),
        }),
      ],
    ];

    return <Table header={evaluationHeader} data={evaluationResults} />;
  }
}

export class EvaluationResultDetail extends React.Component {

  render() {
    const {
      evaluation: {
        envelope,
        air_conditioning,
        lighting_system,
        hot_water_system,
        whole_building_energy,
      },
      carbonSummary,
      t,
    } = this.props;

    // FRS 4.2.3 (4.2) - Operational Carbon (tCO2eq/year)
    // feedback 9/10/2569: ย้ายออกจากตาราง OTTV/RTTV/... (เดิมเป็นคอลัมน์ต่อท้าย + กล่อง Carbon
    // Reduction แยกด้านบน) มาเป็นตารางของตัวเองด้านล่าง: อาคารฐาน (Baseline Building) /
    // อาคารตามที่ออกแบบ + ค่าลดการปลดปล่อยคาร์บอน (= E_savings x EF) คร่อมสองแถว
    const toT = kg => (has_value(kg) ? kg / 1000.0 : null);
    const carbonReferenceT = carbonSummary ? toT(carbonSummary.operational_carbon_reference_kg) : null;
    const carbonDesignedT = carbonSummary ? toT(carbonSummary.operational_carbon_designed_kg) : null;
    const carbonReductionT = carbonSummary ? toT(carbonSummary.carbon_reduction_kg) : null;
    const carbonCell = value => ({
      customStyle: 'text-right',
      value: has_value(value) ? getFormatter(FORMATTER_STYLE.floatFractionDigit2)(value) : '-',
    });

    const acHeader = [
      <span />,
      <span>{t('a/c central')}</span>,
      <span>{t('a/c split type')}</span>,
      <span>{t('a/c packaged unit')}</span>,
      <span>{t('hot water equipment')}</span>,
    ];

    const acResults = [
      [
        t('my building'),
        ({
          value: t(air_conditioning.central_status.toLowerCase()).toUpperCase(),
          customStyle: getStatusStyle(air_conditioning.central_status.toLowerCase()),
        }),
        ({
          value: t(air_conditioning.split_status.toLowerCase()).toUpperCase(),
          customStyle: getStatusStyle(air_conditioning.split_status.toLowerCase()),
        }),
        ({
          value: t(air_conditioning.packaged_status.toLowerCase()).toUpperCase(),
          customStyle: getStatusStyle(air_conditioning.packaged_status.toLowerCase()),
        }),
        ({
          value: t(hot_water_system.status.toLowerCase()).toUpperCase(),
          customStyle: getStatusStyle(hot_water_system.status.toLowerCase()),
        }),
      ],
    ];

    const thermalHeader = [
      <span />,
      <span>{`OTTV (${t('W/sq_m')})`}</span>,
      <span>{`RTTV (${t('W/sq_m')})`}</span>,
      <span>{`LPD (${t('W/sq_m')})`}</span>,
      <span>{`${t('renewable energy')} (${t('kWh/Year')})`}</span>,
      <span>{`${t('whole building energy')} (${t('kWh/Year')})`}</span>,
    ];

    const thermalResults = [
      [
        t('referencing building'),
        ...[
          envelope.OTTV.compliance,
          envelope.RTTV.compliance,
          lighting_system.compliance,
          null,
          whole_building_energy.compliance,
        ].map(value => {
          return {
            customStyle: 'text-right',
            value: has_value(value) ? getFormatter(FORMATTER_STYLE.floatFractionDigit2)(value) : '-',
          }
        }),
      ],
      [
        t('my building'),
        ...[
          envelope.OTTV.all_zone,
          envelope.RTTV.all_zone,
          lighting_system.lighting_power_density,
          whole_building_energy.renewable_energy_PVE + whole_building_energy.renewable_energy_HEE + whole_building_energy.renewable_energy_other,
          whole_building_energy.net_EPA,
        ].map(value => {
          return {
            customStyle: 'text-right',
            value: has_value(value) ? getFormatter(FORMATTER_STYLE.floatFractionDigit2)(value) : '-'
            }
          },
        ),
      ],
      [
        <b>{t('result').toUpperCase()}</b>,
        ...[
          envelope.OTTV.status,
          envelope.RTTV.status,
          lighting_system.status,
          null,
          whole_building_energy.status,
        ].map(
          value =>
            ({
              value: has_value(value) ? t(value.toLowerCase()).toUpperCase() : '-',
              customStyle: (has_value(value) ? getStatusStyle(value.toLowerCase()) : '') + ' text-right',
            })
        ),
      ],
    ];

    const carbonHeader = [
      <span />,
      <span>{`${t('operational carbon')} (${t('tCO2eq per year')})`}</span>,
      <span>{`${t('carbon reduction')} (${t('tCO2eq per year')})`}</span>,
    ];
    const carbonResults = [
      [
        t('baseline building'),
        carbonCell(carbonReferenceT),
        {
          ...carbonCell(carbonReductionT),
          customStyle: 'text-center',
          rowSpan: 2,
          style: { verticalAlign: 'middle', fontWeight: 'bold' },
        },
      ],
      [t('my building'), carbonCell(carbonDesignedT), { skip: true }],
    ];
    return (
      <Fragment>
        <Table header={thermalHeader} data={thermalResults} />
        <br />
        <hr />
        <Table header={acHeader} data={acResults} />
        {carbonSummary && (
          <Fragment>
            <br />
            <hr />
            <Table header={carbonHeader} data={carbonResults} />
          </Fragment>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/evaluation/EvaluationResult.js